var map = {
	"./archive": "FFZZ",
	"./archive.js": "FFZZ",
	"./home": "7qiH",
	"./home.js": "7qiH",
	"./materials": "H9oh",
	"./materials.js": "H9oh",
	"./mould-kits": "pTjO",
	"./mould-kits.js": "pTjO",
	"./shop": "QL/R",
	"./shop.js": "QL/R"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nBtl";